export const INVOICE_VIEW = 'invoice-view';